import { HiPencilAlt } from "react-icons/hi";

export default function EditBtn({ onClick, label }) {
  return (
    <button
      onClick={onClick}
      className="h-5 w-5 text-blue-400 hover:text-blue-700 transition transform hover:scale-110"
      title={label}
    >
      <HiPencilAlt className="w-5 h-5" />
    </button>
  );
}
